import PropTypes from "prop-types";
// form
import { FormProvider as Form } from "react-hook-form";

FormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  methods: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  showSaveBar: PropTypes.bool,
  hasUnsavedChanges: PropTypes.bool,
};

export default function FormProvider({
  children,
  onSubmit,
  methods,
  showSaveBar = undefined,
  hasUnsavedChanges = false,
}) {
  const handleReset = () => {
    methods.reset();
  };

  return (
    <Form {...methods}>
      <form
        data-save-bar={showSaveBar || undefined}
        data-has-unsaved-changes={hasUnsavedChanges || undefined}
        onSubmit={onSubmit}
        onReset={handleReset}
        noValidate
      >
        {children}
      </form>
    </Form>
  );
}
